import React, { useState } from 'react';
import { Link } from 'react-scroll';
import './Navbar.css';

const Navbar = ({ appLogo, changeMenu }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    return (
        <nav className={`navbar ${isMenuOpen ? 'open' : ''}`}>
            <div className="navbar-container">
                <div className="navbar-logo d-flex">
                    <img
                        className="logo-image"
                        src={appLogo}
                        height="50px"
                        width="50px"
                        alt="Kejati Logo"
                        style={{
                            "object-fit": "contain",
                            "border-radius": "8px"
                        }}
                    />
                    <a className="logo-text" href="/">Kejati</a>
                </div>

                <div className={`navbar-links ${isMenuOpen ? 'active' : ''}`}>
                    <ul>
                        <li>
                            <a href='/activity-kejati/home'>Home</a>
                        </li>
                        <li>
                            <a href='/activity-kejati/entry-reservation'>Reservasi</a>
                        </li>                        
                        <li>
                            <a href='/activity-kejati/news'>Berita Terbaru</a>
                        </li>                        
                    </ul>
                </div>

                <div className="navbar-toggle" onClick={toggleMenu}>
                    <span className="bar"></span>
                    <span className="bar"></span>
                    <span className="bar"></span>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;
